import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { collapseExpand, RxRadioModule, RxTextAreaModule } from '@roomex/rx-components';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslocoDirective, TranslocoService } from '@ngneat/transloco';
import { ValidationMessagesModule } from '@rx-applications/clientsite/shared/ui';
import { RadioOption } from '@rx-applications/shared/utils';

enum YesNoType {
  Yes = 'anyCustomRequest.yes',
  No = 'anyCustomRequest.no',
}

@Component({
  selector: 'rx-applications-clientsite-checkout-feature-special-request',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxRadioModule,
    RxTextAreaModule,
    TranslocoDirective,
    ValidationMessagesModule,
  ],
  providers: [translationProvider],
  templateUrl: './clientsite-checkout-feature-special-request.component.html',
  styleUrls: ['./clientsite-checkout-feature-special-request.component.scss'],
  animations: [collapseExpand],
})
export class ClientsiteCheckoutFeatureSpecialRequestComponent implements OnInit {
  @Input() hasSpecialRequest = false;
  @Input() parentForm: UntypedFormGroup;

  readonly #configFacade: ConfigFacade = inject(ConfigFacade);
  readonly #transloco: TranslocoService = inject(TranslocoService);
  readonly translationRoot = 'booking.guestDetails.guestsForm';

  TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  isCustomRequestVisible = false;
  yesNoOptions$: Observable<RadioOption[]>;

  loyaltyViaSpecialRequest$ = this.#configFacade.loyaltyViaSpecialRequest$;

  ngOnInit(): void {
    this.parentForm.addControl('customRequest', new UntypedFormControl('', []));
    this.yesNoOptions$ = this.#transloco
      .selectTranslate<string[]>([YesNoType.Yes, YesNoType.No], {}, TRANSLATION_SCOPE)
      .pipe(
        map(([yes, no]) => [
          { name: yes, id: 'true' },
          { name: no, id: 'false', isSelected: true },
        ])
      );
  }

  get f(): { [key: string]: AbstractControl } {
    return this.parentForm.controls;
  }

  toggleCustomRequest(): void {
    this.isCustomRequestVisible = !this.isCustomRequestVisible;
    if (!this.isCustomRequestVisible) {
      this.f['customRequest'].setValidators(null);
      this.f['customRequest'].clearValidators();
      this.f['customRequest'].setValue('');
    } else {
      this.f['customRequest'].setValidators(Validators.required);
    }
    this.f['customRequest'].updateValueAndValidity();
  }

  doTranslate(ext: string): string {
    return `${this.translationRoot}.${ext}`;
  }
}
